import { render, staticRenderFns } from "./SupplierQualityForm.vue?vue&type=template&id=0b15f7e8&scoped=true&"
import script from "./SupplierQualityForm.vue?vue&type=script&lang=js&"
export * from "./SupplierQualityForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierQualityForm.vue?vue&type=style&index=0&id=0b15f7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15f7e8",
  null
  
)

export default component.exports